import React from "react";
import Button from "react-bootstrap/Button";
import { ModalPreferencesTherapist } from "../components/Therapist/ModalPreferencesTherapist";
import Card from "react-bootstrap/Card";
import Container from "react-bootstrap/Container";
import { TopBar } from "../components";
import { pageTherapistsText, buttonText } from "../lib/constants";
import { TherapistData } from "../components/Therapist/TherapistData";
import { user } from "../components/utils/auth";
import { Filters } from "../components/Filters/Filters";
import { PaginationComponent } from "../components/Therapist/PaginationComponent";
import { useTherapist } from "../hooks/useTherapist";
import { SelectPagination } from "../components/Therapist/SelectPagination";

export const PageTherapists = () => {
    const [modal, setModal] = React.useState(false);
    const therapistData = user();
    const noTherapists = 0;
    const pageIndexOffset = 1;
    
    const {
        therapists,
        loading,
        totalTherapists,
        pageCount,
        currentPage,
        perPage,
        handleFilterSubmit,
        handlePageChange,
        handlePerPageChange,
    } = useTherapist();

    const handleClose = () => setModal(false);

  return (
    <div>
        <ModalPreferencesTherapist modal={modal} handleClose={handleClose} />

        <TopBar content={pageTherapistsText.top_bar_content}/>

        <Container>
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="m-0">{pageTherapistsText.greeting_prefix} {therapistData?.name || ""}</h4>
                    <div>
                        <Button type="button" onClick={() => setModal(true)}>
                        {buttonText.preferences}
                        </Button>
                    </div>
            </div>
        </Container>
        
        <Container className="mt-3" style={{ marginBottom: '7rem' }}>
            <Card>
                <Card.Body>
                    <Card.Title as="h5">{pageTherapistsText.card_title}</Card.Title>
                    <p>{pageTherapistsText.card_text}</p>

                    <Filters onSubmit={handleFilterSubmit} />
                    <SelectPagination perPage={perPage} handlePerPageChange={handlePerPageChange} totalTherapists={totalTherapists} />
                    {loading && <p>{buttonText.loading_users}</p>}

                    {!loading && therapists?.length === noTherapists && (
                    <p>{pageTherapistsText.therapists_not_found}</p>
                    )}

                    {!loading && (
                    <TherapistData therapists={therapists} />
                    )}
                </Card.Body>
                
                <PaginationComponent 
                page={currentPage - pageIndexOffset} 
                pageCount={pageCount} 
                handler={handlePageChange} />
            </Card>
    </Container>
  </div>
  );
};

export default PageTherapists;